import { StatTableCellProps } from "components/StatsTable/StatTableColumn";
import { StatTableLinkColumn } from "./LinkColumn";
import { StatTableTd } from "components/StatsTable/styles";
import { LinkButton } from "./styles";

interface Props<T> extends StatTableCellProps<T, StatTableLinkColumn<T>> {}

export function StatTableLinkCell<T>({
  stats,
  column,
  columnIdx,
  frozenOffset,
}: Props<T>) {
  const link = column.linkGetter(stats);
  return (
    <StatTableTd
      key={`${columnIdx} link ${link}`}
      highlight={column.highlight}
      frozenWidth={column.frozenWidth}
      frozenOffset={frozenOffset}
      border={column.border}
    >
      {!!link && (
        <LinkButton href={link} target="_blank" id="link_button">
          {column.linkText}
        </LinkButton>
      )}
    </StatTableTd>
  );
}
